import { useAuthStore } from "@/features/auth/auth.store";
import { useUserStore } from "@/features/user/user.store";
import { useMutation } from "@tanstack/react-query";
import { passwordApi } from "./password.api";
import { usePasswordStore } from "./password.store";
import type { ForgotPasswordRequest, ResetPasswordRequest, ResetRequest, ResetVerify } from "./password.types";

export const useForgotPassword = () => {
	const setForgotSuccess = usePasswordStore((state) => state.setForgotSuccess);

	return useMutation({
		mutationFn: (request: ForgotPasswordRequest) => passwordApi.forgot(request),
		onSuccess: (data) => setForgotSuccess(data.success),
	});
};

export const useResetPassword = () => {
	const setResetSuccess = usePasswordStore((state) => state.setResetSuccess);

	return useMutation({
		mutationFn: (request: ResetPasswordRequest) => passwordApi.reset(request),
		onSuccess: (data) => setResetSuccess(data.success),
	});
};

export const useResetRequest = () => {
	return useMutation({
		mutationFn: (request: ResetRequest) => passwordApi.resetRequest(request),
	});
};

export const useResetVerify = () => {
	const setAuth = useAuthStore((state) => state.setAuth);
	const setMe = useUserStore((state) => state.setMe);

	return useMutation({
		mutationFn: (request: ResetVerify) => passwordApi.resetVerify(request),
		onSuccess: (data) => {
			if (data.accessToken && data.refreshToken && data.user) {
				setAuth({ accessToken: data.accessToken, refreshToken: data.refreshToken, user: data.user });
				setMe(data.user);
			}
		},
	});
};
